function e(e){return e==null}export{e as isNullish};
//# sourceMappingURL=isNullish-ZR7119t-.js.map